import type { SelectableCardOption } from '../../../types';

interface LifeStatusStepProps {
  relationshipStatus: string;
  dependentsStatus: string;
  onRelationshipChange: (status: string) => void;
  onDependentsChange: (status: string) => void;
}

const RELATIONSHIP_OPTIONS: SelectableCardOption[] = [
  { id: 'single', icon: '👤', title: 'Single' },
  { id: 'partnered', icon: '💑', title: 'With a partner' },
];

const DEPENDENTS_OPTIONS: SelectableCardOption[] = [
  { id: 'kids_young', icon: '👶', title: 'Young children (0-5)' },
  { id: 'kids_school', icon: '🎒', title: 'School-age children (6-17)' },
  { id: 'kids_adult', icon: '🎓', title: 'Adult children (18+)' },
];

export default function LifeStatusStep({
  relationshipStatus,
  dependentsStatus,
  onRelationshipChange,
  onDependentsChange,
}: LifeStatusStepProps) {
  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">Who's counting on this plan?</h2>
        <p className="quiz-step__helper">Whether it's just you or a whole crew, we'll make it work</p>
      </div>

      <div className="quiz-step__body">
        <div className="single-select-grid wide-select-grid">
          {RELATIONSHIP_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              className={`selectable-card selectable-card--compact ${relationshipStatus === option.id ? 'selectable-card--selected' : ''}`}
              onClick={() => onRelationshipChange(option.id)}
            >
              {option.icon && <span className="selectable-card__icon">{option.icon}</span>}
              <div className="selectable-card__content">
                <span className="selectable-card__title">{option.title}</span>
              </div>
              <span className="selectable-card__indicator" aria-hidden="true" />
            </button>
          ))}
          {DEPENDENTS_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              className={`selectable-card selectable-card--compact ${dependentsStatus === option.id ? 'selectable-card--selected' : ''}`}
              onClick={() => onDependentsChange(option.id)}
            >
              {option.icon && <span className="selectable-card__icon">{option.icon}</span>}
              <div className="selectable-card__content">
                <span className="selectable-card__title">{option.title}</span>
              </div>
              <span className="selectable-card__indicator" aria-hidden="true" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
